import { useEffect } from "react";
import type { PDP } from "@shared/graphql.types";
import { useLocale, useUserV2 } from "hooks";
import { siteUrl } from "utils/getSiteUrl";
import { productView } from "utils/gtm";
import { useCurrencyCode } from "hooks/useCurrencyCode";
import { useSegment } from "tracking";

export const useTrackProductViewed = (productDetails: PDP, eventId: string) => {
  const { track } = useSegment();
  const locale = useLocale();
  const { hasMembership } = useUserV2();
  const currencyCode = useCurrencyCode();

  const { prices, sku, title, brandName, subtitle, relatedVariants, slug } =
    productDetails.coreProductInfo;

  useEffect(() => {
    const targetVariant = relatedVariants?.find(
      (variant) => variant.slug === slug
    );

    track(
      {
        event: "Product Viewed",
        properties: {
          currency: locale === "en-GB" ? "GBP" : "USD",
          sku,
          name: title || "",
          brand: brandName || "",
          variant: subtitle || "",
          price: hasMembership ? prices.member : prices.typical,
          members_price: prices.member,
          typical_price: prices.typical,
          url: `${siteUrl}${targetVariant?.url ?? ""}`
        }
      },
      { event_id: eventId }
    );

    //The setTimeout ensures the productView event fires only after the page fully loads.
    //Without it, the event wasn't triggering at all.
    //Making this a temporary workaround that should be revisited later.
    setTimeout(() => {
      productView(
        {
          sku,
          title,
          pricing: {
            members: prices.member,
            typical: prices.typical,
            guest: prices.guest
          },
          subTitle: subtitle || ""
        },
        currencyCode,
        eventId
      );
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
